import React, { useEffect, useState } from "react";
import { Form, Select, Modal, message } from "antd";

import service from ".././services";

const ModalConfirmacaoRecadastramento = ({
  show,
  onConfirm,
  onCancel,
  form,
}) => {
  const [listaDocumentoApresentacaoCenso, setListaDocumentoApresentacaoCenso] =
    useState([]);
  const [valorSelecionado, setValorSelecionado] = useState(null);

  useEffect(() => {
    if (!show) {
      setValorSelecionado(null);
    }
  }, [show]);

  useEffect(() => {
    service
      .listaDocumentoApresentacaoCenso()
      .then((res) => setListaDocumentoApresentacaoCenso(res.data));
  }, []);

  return (
    <Modal
      disabled={false}
      open={show}
      title="Confirmação de Recadastramento"
      okText="Confirmar"
      cancelText="Cancelar"
      onOk={() => {
        if (!valorSelecionado) {
          message.error("Documento apresentado é obrigatório");
          return;
        }

        form.setFieldsValue({
          documentoApresentado: valorSelecionado,
        });

        onConfirm();
      }}
      onCancel={onCancel}
      destroyOnClose
    >
      <p style={{ color: "red" }}>
        <b>
          O documento de identificação apresentado deve ser original, conter
          foto e estar dentro do prazo de validade, quando aplicável.
        </b>
      </p>
      <p style={{ color: "red" }}>
        <b>Maiores informações no telefone (62) 3201-7828.</b>
      </p>

      <div style={{ marginTop: 16 }}>
        <label style={{ fontWeight: 500 }}>
          Documento Apresentado <span style={{ color: "red" }}>*</span>
        </label>

        <Select
          disabled={false}
          placeholder="Selecione o Documento"
          value={valorSelecionado?.id}
          onChange={(value) => {
            const objetoCompleto = listaDocumentoApresentacaoCenso.find(
              (m) => m.id === value
            );

            setValorSelecionado(objetoCompleto);
          }}
          allowClear
          style={{ width: "100%" }}
        >
          {listaDocumentoApresentacaoCenso.map((d) => (
            <Select.Option key={d.id} value={d.id}>
              {d.descricao}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
};

export default ModalConfirmacaoRecadastramento;
